import { SavedFilter } from './types';
import * as React from 'react';

type SelectedFilterSetter = (filter: SavedFilter) => void;
type SelectedFilterContextValues = [SavedFilter, SelectedFilterSetter];

const SelectedFilterContext =
  // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
  React.createContext<SelectedFilterContextValues>(null);

/**
 * @description A hook for reading and setting the currently selected filter.
 * This is used by our Saved Filter components to determine the currently-selected
 * filter.
 */
function useSelectedFilter() {
  const context = React.useContext(SelectedFilterContext);

  if (!context) {
    throw new Error(
      'useSelectedFilter must be used within a SelectedFilterContext',
    );
  }

  return context;
}

function SelectedFilterProvider(props: any) {
  // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
  const [selectedFilter, setSelectedFilter] = React.useState<SavedFilter>(null);

  const value = React.useMemo(
    () => [selectedFilter, setSelectedFilter],
    [selectedFilter],
  );

  return <SelectedFilterContext.Provider value={value} {...props} />;
}

export { SelectedFilterProvider, useSelectedFilter };
